import * as history from '../../services/history';

export default {
  namespaced: true,

  state: {
    totalSeconds: 0,
    todaySeconds: 0,
    streakDays: 0,
    sessionCount: 0,
    avgAccuracy7d: null,
    recentSessions: [],
    perVideo: [],
    perSentence: [],
    byVideo: [],
    // Reset when a session is recorded.
    currentSegmentSeconds: 0
  },

  mutations: {
    SET_STATS(state, stats) {
      state.totalSeconds = stats.totalSeconds;
      state.todaySeconds = stats.todaySeconds;
      state.streakDays = stats.streakDays;
      state.sessionCount = stats.sessionCount;
      state.avgAccuracy7d = stats.avgAccuracy7d;
      state.recentSessions = stats.recentSessions;
      state.perVideo = stats.perVideo;
      state.perSentence = stats.perSentence || [];
      state.byVideo = stats.byVideo || [];
    },

    ADD_PRACTICE_SECONDS(state, seconds) {
      state.totalSeconds += seconds;
      state.todaySeconds += seconds;
      state.currentSegmentSeconds += seconds;
    },

    RESET_SEGMENT_SECONDS(state) {
      state.currentSegmentSeconds = 0;
    }
  },

  actions: {
    refreshStats({ commit }) {
      commit('SET_STATS', history.getStats());
    },

    addPracticeTime({ commit }, seconds) {
      history.addPracticeTime(seconds);
      commit('ADD_PRACTICE_SECONDS', seconds);
    },

    recordSession({ commit, state, dispatch }, session) {
      history.addSession({
        durationSec: Math.round(state.currentSegmentSeconds),
        ...session
      });
      commit('RESET_SEGMENT_SECONDS');
      dispatch('refreshStats');
    },

    resetSegmentTimer({ commit }) {
      commit('RESET_SEGMENT_SECONDS');
    }
  }
};
